import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface DeleteCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  categoryName: string;
}

const DeleteCategoryModal: React.FC<DeleteCategoryModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  categoryName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          width: "500px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">Delete Category</h3>
      <p className="mt-3 text-sm text-gray-600">
        Are you sure you want to delete the category &apos;{categoryName}&apos;?
      </p>

      <div className="mt-3 flex items-start gap-3 rounded-md bg-yellow-50 border border-yellow-200 p-3">
        <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600 shrink-0 mt-0.5" />
        <p className="text-sm text-yellow-800">This action cannot be undone.</p>
      </div>

      <div className="mt-6 flex justify-end space-x-3">
        <Button className="rounded-md" onClick={onClose} variant="plain">
          Cancel
        </Button>
        <Button className="rounded-md" onClick={onConfirm} variant="default">
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteCategoryModal;
